// Port of api/fuel/app/classes/filter/search/games/filters/post/play/players.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import Player from 'offline/model/player'
import Helpers from 'offline/filter/core/helpers'

export default {
	name: 'post.play.players',
	priority: 56,
	post: true,
	require: function(config, filter) {
		return filter.play && filter.play.players && filter.play.players.required && filter.play.players.required.length > 0
	},
	run: function(config, filter, data, results) {
		if (!results.concat || !results.concat.p) return results
		var playIds = results.concat.p.map(function(v) { return parseInt(v) }).filter(function(v) { return v > 0 })
		if (!playIds.length) return results
		var required = filter.play.players.required
		var together = filter.play.players.together

		var playerPlayIndex = []
		var first = true

		for (var i = 0; i < required.length; i++) {
			var player = Player.with_id(required[i])
			if (!player) continue

			var whereField = ''
			var whereValue = ''
			if (player.get_user_id()) {
				whereField = 'pl.user_id'
				whereValue = player.get_user_id()
			} else if (player.get_username()) {
				whereField = 'pl.player_username'
				whereValue = '"' + String(player.get_username()).replace(/"/g, '\\"') + '"'
			} else {
				whereField = 'pl.player_name'
				whereValue = '"' + String(player.get_name()).replace(/"/g, '\\"') + '"'
			}

			var namePlayRows = DB.query(
				'SELECT pl.play_id AS p FROM player pl, play p WHERE p.play_id = pl.play_id AND p.user_id IN(' + Util.in(data.users) + ') AND ' + whereField + ' = ' + whereValue
			)
			var namePlayIndex = Util.pluck(namePlayRows, 'p').map(function(id) {
				return parseInt(id, 10)
			}).filter(Boolean)

			if (first) {
				playerPlayIndex = namePlayIndex
				first = false
			} else if (together) {
				playerPlayIndex = playerPlayIndex.filter(function(id) { return namePlayIndex.indexOf(id) !== -1 })
			} else {
				playerPlayIndex = playerPlayIndex.concat(namePlayIndex)
			}
		}

		if (config.resultType === F.RESULT_GAME) {
			var gameRows = DB.query('SELECT game_id FROM play WHERE play_id IN(' + Util.in(playerPlayIndex) + ') AND play_id IN(' + Util.in(playIds) + ')')
			var gameIndex = Util.pluck(gameRows, 'game_id').map(function(id) { return parseInt(id, 10) }).filter(Boolean)
			results.index = Helpers.preserve_sort(results.index, gameIndex.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
		} else {
			results.index = Helpers.preserve_sort(results.index, playerPlayIndex.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
		}

		return results
	}
}
